export const countryColors: Record<string, string> = {
  defaultCountryColor: "#E5E5E5",
  hoverCountryColor: "#CED6DE",
  defaultActiveCountryColor: "#E8F3FF",
  hoverActiveCountryColor: "#DDEEFF",
  pressedCountryColor: "#B1BECC",
  pressedActiveCountryColor: "#DDEEFF",
};

export const tooltipTextStyles = {
  container: "border: 2px solid #1D5083; padding: 6px; border-radius: 6px; display: inline-block;",
  header: "display: flex; align-items: center; justify-content: center; gap: 15px; margin-bottom: 4px; padding: 6px;",
  flagImg: "width: 48px; height: 32px; border-radius: 2px; box-shadow: 0 0 2px #aaa;",
  title: "margin: 0; font-size: 16px; font-weight: 600;",
  divider: "flex: 1; height: 1px; background-color: #1D5083;",
  paragraph: "padding: 6px; text-align: justify;",
  boldCenter: "margin: 6px 0; font-weight: bold; text-align: center;",
  eqfDot: (dotColor: number) => `color: ${dotColor}; font-size: 14px;`,
  typeRow: "margin: 6px 0; text-align: center;",
  boldText: "margin-left: 4px; font-weight: bold;",
};

export const getGeographyStyle = (
  countryName: string,
  activeCountries: string[],
  colors: {
    fill: string;
    hover: string;
    pressed: string;
  },
) => {
  const isActive = activeCountries.includes(countryName);
  const cursor = isActive ? "pointer" : "default";

  return {
    default: {
      fill: colors.fill,
      stroke: "#656D78",
      strokeWidth: 0.1,
      outline: "none",
      transition: "all 0.3s ease-in-out",
      cursor,
    },
    hover: {
      fill: colors.hover,
      stroke: "#FAFAFA",
      strokeWidth: 0.3,
      outline: "none",
      transition: "all 0.3s ease-in-out",
      cursor,
    },
    pressed: {
      fill: colors.pressed,
      stroke: "#fff",
      strokeWidth: 0.1,
      outline: "none",
      cursor,
    },
  };
};

export const getTooltipStyle = (mousePosition: { x: number; y: number }) => ({
  position: "fixed" as const,
  top: `${mousePosition.y + 5}px`,
  left: `${mousePosition.x + 5}px`,
  background: "#F8FBFD",
  color: "#000",
  padding: "10px",
  borderRadius: "10px",
  fontSize: "12px",
  maxWidth: "300px",
  lineHeight: "1.5",
  fontFamily: "sans-serif",
  transition: "opacity 0.0s ease-in-out",
});
